// Logic THUẦN (không DOM) của trang Bot / Chờ duyệt / khung trang — tách riêng để kiểm bằng unit test (rà soát người dùng 05/10, nhóm C).
import type { ChoDuyetItem } from "../../../src/shared/kich-ban-tu-sua";

/** L1: so tên bot TỰ NHIÊN — "Máy 1, Máy 2, Máy 10" (không "Máy 1, Máy 10, Máy 2"); tiếng Việt; hoa/thường như nhau, hoà thì phân định ổn định. */
export function soSanhTenBot(a: string, b: string): number {
  return a.localeCompare(b, "vi", { numeric: true, sensitivity: "base" }) || a.localeCompare(b, "vi", { numeric: true }) || (a < b ? -1 : a > b ? 1 : 0);
}

const chuanTen = (s: string): string => s.normalize("NFC").trim().replace(/\s+/g, " ").toLocaleLowerCase("vi");

/** L2 (phía Boss): id các bot TRÙNG TÊN với bot khác của CÙNG chủ (bỏ khoảng trắng thừa, không phân biệt hoa/thường). */
export function botTrungTen(bots: { id: string; ownerId: string; name: string }[]): Set<string> {
  const nhom = new Map<string, string[]>();
  for (const b of bots) {
    const k = `${b.ownerId}\u0000${chuanTen(b.name)}`;
    nhom.set(k, [...(nhom.get(k) ?? []), b.id]);
  }
  const out = new Set<string>();
  for (const ids of nhom.values()) if (ids.length > 1) for (const id of ids) out.add(id);
  return out;
}

/** N6: chữ "còn bao lâu" tới lúc câu chờ duyệt bị huỷ. null = không có hạn. gap = còn dưới 15 phút (tô cảnh báo). */
export function conLaiChoDuyet(hetHanLuc: string | null | undefined, nowMs: number): { chu: string; gap: boolean; het: boolean } | null {
  if (!hetHanLuc) return null;
  const t = Date.parse(hetHanLuc);
  if (!Number.isFinite(t)) return null;
  const ms = t - nowMs;
  if (ms <= 0) return { chu: "đã quá hạn chờ duyệt", gap: true, het: true };
  const phut = Math.ceil(ms / 60_000);
  const chu = phut < 1 ? "dưới 1 phút" : phut < 60 ? `${phut} phút` : `${Math.floor(phut / 60)} giờ${phut % 60 ? ` ${phut % 60} phút` : ""}`;
  return { chu: `còn ${chu} để duyệt`, gap: ms < 15 * 60_000, het: false };
}

/** N2: câu nào thuộc Boss KHÁC người đang duyệt (chỉ Super thấy ownerName) — để hỏi lại rõ trước khi duyệt thay. */
export function cauCuaBossKhac(items: Pick<ChoDuyetItem, "ownerName">[], toi: string | null | undefined): string[] {
  const ds = new Set<string>();
  for (const it of items) if (it.ownerName && it.ownerName !== toi) ds.add(it.ownerName);
  return [...ds].sort((a, b) => a.localeCompare(b, "vi"));
}

/** N2: một dòng ngắn của câu sẽ đăng (dải "Cần bạn", hộp xác nhận): gộp khoảng trắng, cắt theo KÝ TỰ (emoji không bị cắt đôi). */
export function motDong(s: string | null | undefined, toiDa = 140): string {
  const t = (s ?? "").replace(/\s+/g, " ").trim();
  const kt = Array.from(t);
  return kt.length > toiDa ? `${kt.slice(0, toiDa - 1).join("")}…` : t;
}

// ---------------- V2: thẻ "Bắt đầu" cho người mới ----------------
export interface TrangThaiBatDau { soBot: number; soSanPham: number; soKichBan: number; daChayThu: boolean; daChayThat: boolean }
export interface BuocBatDau { id: "cai" | "ghep" | "san-pham" | "kich-ban" | "chay-thu" | "chay-that"; ten: string; giai: string; xong: boolean }

export function buocBatDau(t: TrangThaiBatDau): BuocBatDau[] {
  const coBot = t.soBot > 0;
  return [
    { id: "cai", ten: "Cài bot lên máy sẽ chạy", giai: "Tải bản cài bot (plugin trình duyệt) và cài trên máy tính dùng để đăng bài/bình luận.", xong: coBot },
    { id: "ghep", ten: "Ghép bot với Boss", giai: "Bấm Thêm bot để lấy mã, dán mã vào bot trên máy đó. Bot hiện ở trang này khi nối xong.", xong: coBot },
    { id: "san-pham", ten: "Thêm sản phẩm (nếu muốn quảng bá)", giai: "Tải tài liệu, ảnh sản phẩm một lần — bình luận sẽ nhắc đúng sản phẩm của bạn.", xong: t.soSanPham > 0 },
    { id: "kich-ban", ten: "Tạo kịch bản", giai: "Gõ mong muốn bằng lời (ví dụ: bình luận 3 bài về nước mắm trên Facebook), AI viết thành các bước.", xong: t.soKichBan > 0 },
    // (08/10/2026, người dùng bỏ Nháp) giữ mã bước cũ; không còn bước "chạy thử".
    { id: "chay-thu", ten: "Chạy trên một bot", giai: "Mở kịch bản, chọn bot, bấm ▶ Chạy — bot làm thật, bước gửi/đăng dừng chờ bạn duyệt.", xong: t.daChayThu || t.daChayThat },
    { id: "chay-that", ten: "Duyệt câu sẽ đăng", giai: "Câu AI soạn chờ bạn duyệt ở trang Chờ duyệt trước khi bot đăng.", xong: t.daChayThat },
  ];
}
/**
 * Hiện thẻ khi người dùng còn MỚI: chưa có bot, hoặc có bot mà chưa có kịch bản và chưa từng chạy gì. Boss đã chạy việc (kể cả bằng kịch bản
 * học trong plugin, không phải sơ đồ) thì không còn là người mới — không chèn thẻ hướng dẫn vào trang làm việc.
 */
export function canHienBatDau(t: TrangThaiBatDau): boolean {
  const moi = t.soBot === 0 || (t.soKichBan === 0 && !t.daChayThu && !t.daChayThat);
  return moi && buocBatDau(t).some((b) => !b.xong);
}
